import { ClosingCta } from "@frontend/components/site/closing-cta";
import { Faq, FAQS } from "@frontend/components/site/faq";
import { branding } from "@creators/backend/lib/config";
import { Seo } from "@frontend/lib/seo";
import { useViewer } from "@frontend/lib/viewer";

const DESCRIPTION =
  "Payments, escrow, quiet counterparties, barter, and Serious/Priority offers — answers before you sign up.";

export function FaqPage() {
  const { viewer } = useViewer();
  const signedIn = Boolean(viewer && !viewer.isAdmin);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };

  return (
    <main>
      <Seo
        title={`Questions — ${branding.name}`}
        description={DESCRIPTION}
        path="/faq"
        jsonLd={faqSchema}
      />
      <Faq />
      <ClosingCta signedIn={signedIn} />
    </main>
  );
}
